import { Box, Typography, Paper, Backdrop, CircularProgress } from '@mui/material';
import { useEffect, useRef } from 'react';
import { useReportContext } from '../ReportContext';
import { tdstcsdata } from '../../newReports/data';
import { useSearchParams, useParams } from 'react-router-dom';
// import NewTDSTCSReport from '../../../components/Table/NewTDSTCSReport';
import NewTDSTCSReport from '../../../../components/Table/NewTDSTCSReport';

const TDSTCSReports = () => {
  const { updateReportData, setLoading, loading } = useReportContext();
  const [searchParams] = useSearchParams();
  const { id: reportId } = useParams();
  const previousReportIdRef = useRef(reportId);

  // Map account IDs to report types
  const reportTypeMap = {
    '01': { reportType: 'TCSPAY', tableName: 'TCS Payable Report' },
    '02': { reportType: 'TCSREC', tableName: 'TCS Receivable Report' },
    '03': { reportType: 'TDSPAY', tableName: 'TDS Payable Report' },
    '04': { reportType: 'TDSREC', tableName: 'TDS Receivable Report' },
  };

  // Clear data when report ID changes
  useEffect(() => {
    if (previousReportIdRef.current !== reportId && previousReportIdRef.current !== null) {
      // Report ID changed, clear data
    }
    previousReportIdRef.current = reportId;
  }, [reportId]);

  // Get selected account IDs from URL
  const idsParam = searchParams.get('ids');
  const selectedIds = idsParam
    ? decodeURIComponent(idsParam)
        .split(',')
        .filter(Boolean)
        .map((id) => id.trim())
    : [];

  // Get selected reports based on account IDs in URL
  const selectedReports = selectedIds
    .filter((id) => reportTypeMap[id])
    .map((id) => ({
      accountId: id,
      ...reportTypeMap[id],
    }));

  return (
    <Box sx={{ width: '100%', maxWidth: '100%', overflowX: 'hidden' }}>
      {selectedReports?.map((report) => (
        <Box key={report.accountId}>
          <NewTDSTCSReport reportType={report.reportType} tableName={report.tableName} setLoading={setLoading} />
        </Box>
      ))}
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
};

export default TDSTCSReports;
